var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "dialog-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.handleClose.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "dialog-content",
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("div", [
            _c(
              "button",
              {
                staticClass: "close-button",
                attrs: { type: "button" },
                on: { click: _vm.handleClose },
              },
              [_c("span", { staticClass: "close-icon" }, [_vm._v("×")])]
            ),
          ]),
          _c("div", { staticClass: "dialog-body" }, [
            _c(
              "div",
              { staticClass: "cat-icon-container" },
              [
                _c("CatIcon", {
                  attrs: {
                    clickable: false,
                    size: "large",
                    writerType: "IMPS",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "description" }, [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t("myPage.writerTypeIndicatorSkipDialog.description")
                  )
                ),
              ]),
              _c("p", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "myPage.writerTypeIndicatorSkipDialog.skipDescription"
                      )
                    ) +
                    " "
                ),
              ]),
              _c("p", { staticClass: "note" }, [
                _vm._v(
                  _vm._s(_vm.$t("myPage.writerTypeIndicatorSkipDialog.note"))
                ),
              ]),
            ]),
            _c("div", { staticClass: "button-wrapper" }, [
              _c(
                "button",
                {
                  staticClass: "btn-skip",
                  on: { click: _vm.handleSkipAndChangeMode },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "myPage.writerTypeIndicatorSkipDialog.skipAndChangeButton"
                        )
                      ) +
                      " "
                  ),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "btn-indicator",
                  on: { click: _vm.onClickWriterTypeIndicator },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "myPage.writerTypeIndicatorSkipDialog.takeTestButton"
                        )
                      ) +
                      " "
                  ),
                ]
              ),
              _c(
                "button",
                { staticClass: "btn-cancel", on: { click: _vm.handleClose } },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "myPage.writerTypeIndicatorSkipDialog.cancelButton"
                        )
                      ) +
                      " "
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }